import { memo, useContext } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import templateFetcherHook from "service/template-fetcher-hook";
import List from "./list/list";
import Add from "./add/add";
import Edit from "./edit/edit";
import EnumsContext from "context/initialize-context";

const Product = props => {
    const {
        template
    } = props;

    const enumsData = useContext(EnumsContext);
    const { data: pageData } = templateFetcherHook(template);
    const params = useParams();
    const { addId, id } = params;
    const [searchParams] = useSearchParams();

    return (
        <div className="m-container">
            <div className={`relative transition-all ${!searchParams.get("form_id") ? "p-4" : ""}`}>
                {
                    !searchParams.get("form_id") && (
                        <div className="pos-cover select-form-lightbox">
                            {
                                enumsData.data.forms.map((form, i) => (
                                    <div className="m-block" key={`form-block-${i}`}>
                                        <Link to={`?form_id=${form.id}`}>
                                            <span>
                                                <i className="fa-light fa-list-check"></i>
                                            </span>

                                            {form.title}
                                        </Link>
                                    </div>
                                ))
                            }
                        </div>
                    )
                }

                {
                    addId ? (
                        <Add
                            pageData={pageData}
                            formId={addId}
                        />
                    ) : (
                        id
                            ? <Edit pageData={pageData} id={id} />
                            : <List pageData={pageData} />
                    )
                }
            </div>
        </div>
    )
}

export default memo(Product);